<script setup lang="ts">
// Par Depositar/Sacar do design system V2. Existia duplicado inline em
// Header.vue e CoinsCard.vue (duas variantes de tamanho); virou 3ª cópia
// com ScreenWallet.vue, então consolidei aqui.
const { openDepositModal, openWithdrawModal } = usePayments();
const { userCanOnlyWithdraw, canWithdraw } = useUserV2PaymentsGate();

// volta a abrir a modal de saque legada de verdade: é onde mora o fluxo real
// (valor, mín/máx, aviso de perda de bônus, gate de KYC da 1ª retirada em
// components/withdraw/index.vue) — o painel V2 ainda não tem uma tela própria
// de formulário de saque, então navegar só pra Carteira virava beco sem
// saída (o botão não fazia nada de real).
type Props = {
  // 'default' = Header.vue (empilhado). 'compact' = ScreenWallet.vue (lado a
  // lado, mesma altura/raio/fonte do 'default'). 'card' = CoinsCard.vue
  // (lado a lado, dimensões menores — card mobile não tem espaço pro par
  // em tamanho padrão).
  size?: 'default' | 'compact' | 'card';
};

const { size = 'default' } = defineProps<Props>();

const buttonSizeClass = {
  default:
    'h-[40px] w-full rounded-[12px] px-[16px] text-[14px] leading-[20px]',
  compact:
    'h-[40px] flex-1 rounded-[12px] px-[16px] text-[14px] leading-[20px]',
  card: 'h-[32px] flex-1 rounded-[8px] px-[12px] text-[12px] leading-[16px]',
}[size];
</script>

<template>
  <!-- w-[180px] fixo no 'default' (não flex-1): antes disputava 50/50 com a
       coluna do nome do Header desktop, e o chip "Falar com meu gerente"
       (VIP 4+) acabava sem espaço pra caber inteiro. Fixo = sobra sempre pra
       coluna do nome, sem depender de quem "cede" primeiro no flex. -->
  <div
    class="flex gap-[6px]"
    :class="size === 'default' ? 'w-[180px] shrink-0 flex-col' : 'w-full'"
  >
    <button
      v-if="!userCanOnlyWithdraw"
      class="flex items-center justify-center bg-v2-secondary text-v2-secondary-foreground"
      :class="buttonSizeClass"
      type="button"
      @click="openDepositModal"
    >
      Depositar
    </button>

    <button
      class="border-solid flex items-center justify-center border-2 border-white text-white disabled:cursor-not-allowed disabled:border-white/30 disabled:text-white/30"
      :class="buttonSizeClass"
      :disabled="!canWithdraw"
      type="button"
      @click="openWithdrawModal"
    >
      Sacar
    </button>
  </div>
</template>
